import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';

export const useSetHighlightedIdState = () => {
  const setState = useSetState();

  const setHighlightedIdState = useCallback(
    (id?: string) => {
      setState((prev) => {
        return {
          ...prev,
          highlightedId: id,
        };
      });
    },
    [setState],
  );

  return setHighlightedIdState;
};
